<div class="modal__content">
  <div class="confirmation-popup-header">
    <i class="fa fa-chart-line"></i>
    <span>PROJECTION NAME</span>
  </div>

  <div class="confirmation-popup-text">
    <div class="form-group">
      <label class="form-label">Statement Date: <strong>{{ statementDate }}</strong></label>
    </div>
    <div class="form-group mb-3">
      <label class="form-label">Reporting: <strong>{{ formatReportingInterval(reportingInterval) }}</strong></label>
    </div>
    <div class="form-group">
      <label for="projection-name" class="input-label"><strong>Enter Projection Name</strong></label>
      <div class="input-group">
        <input
          type="text"
          id="prompt-for-projection-name-label"
          class="form-control"
          placeholder="Projection Name"
          [formControl]="projectionNameControl"
          [ngClass]="{'is-invalid': (hasError || (projectionNameControl.invalid && (projectionNameControl.dirty || submitAttempt)))}"
          >
        @if (projectionNameControl.hasError('maxlength')) {
          <div class="invalid-feedback">
            Maximum of 200 characters
          </div>
        }
      </div>
    </div>
    @if (hasError) {
      <div class="text-danger">
        {{ errorMessage }}
      </div>
    }
  </div>
</div>
<div class="modal__footer d-flex justify-content-end">
  <button type="reset" class="btn btn-link" (click)="this.popup.close(true, false)">Cancel</button>
  <button
    type="submit"
    class="btn btn-primary"
    (click)="save()"
    >
    Save
  </button>
</div>
